<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recovery Details
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organSpecification"
              disabled
              label="Organ Specification"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="surgeonOne"
              disabled
              label="Surgeon One"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartDate"
              disabled
              label="Recovery Start Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryStartTime"
              disabled
              label="Recovery Start Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndDate"
              disabled
              label="Recovery End Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="recoveryEndTime"
              disabled
              label="Recovery End Time"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampDate"
              disabled
              label="Cross Clamp Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="crossClampTime"
              disabled
              label="Cross Clamp Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushDate"
              disabled
              label="Flush Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="flushTime"
              disabled
              label="Flush Time"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="comments"
              disabled
              label="Comments"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="completed"
              disabled
              label="Completed"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="organShipped"
              disabled
              label="Organ Shipped"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="shippedOutOfProvince"
              disabled
              label="Shipped OOP"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="perfusionPump"
              disabled
              label="Perfusion Pump"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="perfusionDate"
              disabled
              label="Perfusion Date"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="successfullyTransplanted"
              disabled
              label="Successfully Transplanted"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "RecoveryDetailsSection",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      organSpecification: this.getOrganSpecification( this.patientBundle ),
      surgeonOne: this.getSurgeonOne( this.patientBundle ),
      recoveryStartDate: this.getRecoveryStartDate( this.patientBundle )?.substring( 0,10 ),
      recoveryStartTime: this.getRecoveryStartDate( this.patientBundle )?.substring( 11,19 ),
      recoveryEndTime: this.getRecoveryEndDate( this.patientBundle )?.substring( 11,19 ),
      recoveryEndDate: this.getRecoveryEndDate( this.patientBundle )?.substring( 0,10 ),
      crossClampDate: this.getCrossClampDate( this.patientBundle )?.substring( 0,10 ), 
      crossClampTime: this.getCrossClampDate( this.patientBundle )?.substring( 11,19 ),
      flushDate: this.getFlushDate( this.patientBundle )?.substring( 0,10 ),
      flushTime: this.getFlushDate( this.patientBundle )?.substring( 11,19 ),
      comments: this.getComments( this.patientBundle ),
      completed: this.getCompleted( this.patientBundle ),
      organShipped: this.getOrganShipped( this.patientBundle ),
      shippedOutOfProvince: this.getShippedOutOfProvince( this.patientBundle ),
      perfusionPump: this.getPerfusionPump( this.patientBundle ),
      perfusionDate: this.getPerfusionDate( this.patientBundle ),
      successfullyTransplanted: this.getOrganSuccessfullyTransplanted( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getOrganSpecification( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let organSpecification = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#395' ) ) ;
      if( organSpecification && organSpecification[ 0 ] ) {
        return _.get( organSpecification[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getSurgeonOne( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let surgeonOne = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#112' ) ) ;
      if( surgeonOne && surgeonOne[ 0 ] ) {
        return _.get( surgeonOne[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getRecoveryStartDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#398' ) ) ;
      if( recoveryStartDate && recoveryStartDate[ 0 ] ) {
        return _.get( recoveryStartDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getRecoveryEndDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recoveryEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#399' ) ) ;
      if( recoveryEndDate && recoveryEndDate[ 0 ] ) {
        return _.get( recoveryEndDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getCrossClampDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let crossClampDate= observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#400' ) ) ;
      if( crossClampDate && crossClampDate[ 0 ] ) {
        return _.get( crossClampDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getFlushDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#114' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16539' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCompleted( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16540' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getOrganShipped( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16542' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getShippedOutOfProvince( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16569' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getPerfusionPump( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16571' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
    getPerfusionDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16572' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueDateTime' )?.substring( 0,10 );
      } 
      }
    },
    getOrganSuccessfullyTransplanted( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let flushDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16573' ) ) ;
      if( flushDate && flushDate[ 0 ] ) {
        return _.get( flushDate[ 0 ], 'resource.component[0].valueBoolean' ) ? 'Yes' : 'No';
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 340px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}
.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 600px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
  width: 400px;
}

</style>
